import React, { Component } from "react";
import styled from "styled-components";
import shunzeBg from "../../assets/homePage/shunze.png";

import {
  institutionsName,
  institutionsType,
} from "@/database/institutions.json";

const Div = styled.div`
  height: 14rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .pageTitle-container {
    height: 100%;
    width: 120rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-name {
      font-size: 2.8rem;
      color: #1677ff;
      font-weight: normal;
    }

    .title-button {
      color: #ffffff;
      width: 11.1rem;
      height: 4rem;
      border-radius: 0.4rem;
      background-color: #1677ff;
      font-size: 1.6rem;
      font-weight: normal;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 100ms ease-in-out;

      &:hover {
        border: 1px solid #1677ff;
        color: #1677ff;
        background-color: #ffffff;
      }
    }
  }
`;

class PageTitle extends Component {
  handleSignUpClick = () => {
    this.props.history.push("/signup");
  };

  render() {
    return (
      <Div>
        <div className="pageTitle-container">
          <div className="title-name">
            {/* <img src={shunzeBg} alt=""  style={{width:600}}/> */}
            {institutionsName + institutionsType}
          </div>
          <div onClick={this.handleSignUpClick} className="title-button">
            <div>学习报名</div>
          </div>
        </div>
      </Div>
    );
  }
}

export default PageTitle;
